module.exports = __webpack_public_path__ + "img/huobi.c1776b12.png";